import { gql } from '@apollo/client'

const featuredVideosFragment = gql`
  fragment featuredVideosFragment on PublicProfile {
    featuredVideos {
      id
      from
      to
      videoUrl(preset: VIDEO_DEFAULT)
      thumbnailUrl(format: { height: 650 })
      duration
      requestOccasion {
        id
        internalName
        title
        emoji
        color
      }
      review {
        rating
        tags
        messageToProfile
      }
    }
  }
`

export default featuredVideosFragment
